/*! *********************************************************************
 *
 * Copyright 2023 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************
 */

import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  DateField,
  Filter,
  EditButton,
} from 'react-admin';

import Pagination from '../../components/Pagination';

import StatusSelectorInput from '../../components/StatusSelectorInput';

const ThemesFilter = (props) => (
  <Filter {...props}>
    <StatusSelectorInput label="Status" source="status" alwaysOn />
  </Filter>
);

const ThemesGrid = (props) => (
  <Datagrid>
    <TextField source="weight" label="Position" sortable={false} />
    <TextField source="title" sortable={false} />
    <TextField source="nbCollections" label="Nb collections" sortable={false} />
    <TextField source="status" sortable={false} />
    <DateField source="createdAt" showTime sortable={false} />
    <DateField source="updatedAt" showTime sortable={false} />
    {props.hasEdit && <EditButton />}
  </Datagrid>
);

function ThemesList(props) {
  return (
    <List
      {...props}
      title="Themes Listing"
      pagination={<Pagination />}
      perPage={100}
      filters={<ThemesFilter />}
      exporter={false}
    >
      <ThemesGrid {...props} />
    </List>
  );
}

export default ThemesList;
